import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Seo, { breadcrumbSchema, localBusinessSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/Btn";
import { Breadcrumb } from "@/components/Breadcrumb";
import QuoteForm from "@/components/QuoteForm";
import { COMPANY } from "@/data/company";

export default function Contact() {
  const crumbs = [
    { label: "Accueil", to: "/" },
    { label: "Contact / Devis", to: "/contact/" },
  ];
  return (
    <>
      <Seo
        title="Contact & Demande de devis | Ronalp Enseigne"
        description="Demandez votre devis d'enseigne lumineuse ou de communication visuelle. Ronalp Enseigne, Saint-Jean-de-Gonville (01) — France & Suisse. Réponse rapide, étude gratuite."
        path="/contact/"
        jsonLd={[localBusinessSchema(), breadcrumbSchema(crumbs)]}
      />
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-30" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
          <Breadcrumb items={crumbs} />
          <Reveal className="mt-8 max-w-3xl">
            <Overline>Contact / Devis</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white leading-[0.98]">Parlons de votre projet</h1>
            <p className="mt-5 text-lg text-slate-300">Décrivez votre projet d'enseigne, de signalétique ou de communication visuelle. Nous vous recontactons rapidement pour une étude et un devis gratuits.</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            <QuoteForm />
          </div>
          <aside className="lg:col-span-2 space-y-5">
            <div className="rounded-2xl border border-white/10 bg-ink-800 p-7">
              <h2 className="text-lg font-semibold text-white mb-5">Coordonnées</h2>
              <ul className="space-y-5 text-sm">
                <li><a href={COMPANY.phoneHref} className="flex items-start gap-3 text-slate-300 hover:text-white transition-colors"><Phone className="h-5 w-5 text-signature mt-0.5" /><span><span className="block text-chrome-dark font-mono text-xs uppercase">Téléphone</span>{COMPANY.phone}</span></a></li>
                <li><a href={COMPANY.emailHref} className="flex items-start gap-3 text-slate-300 hover:text-white transition-colors"><Mail className="h-5 w-5 text-signature mt-0.5" /><span><span className="block text-chrome-dark font-mono text-xs uppercase">Email</span>{COMPANY.email}</span></a></li>
                <li className="flex items-start gap-3 text-slate-300"><MapPin className="h-5 w-5 text-signature mt-0.5" /><span><span className="block text-chrome-dark font-mono text-xs uppercase">Adresse</span>{COMPANY.address.street}<br />{COMPANY.address.postalCode} {COMPANY.address.city}</span></li>
                <li className="flex items-start gap-3 text-slate-300"><Clock className="h-5 w-5 text-signature mt-0.5" /><span><span className="block text-chrome-dark font-mono text-xs uppercase">Zones</span>Ain, Pays de Gex, Haute-Savoie, Lyon, Genève, Vaud</span></li>
              </ul>
            </div>
            <div className="rounded-2xl border border-white/10 bg-ink-800 p-7">
              <h2 className="text-lg font-semibold text-white mb-3">Nos engagements</h2>
              <ul className="space-y-2.5 text-sm text-slate-400">
                <li>• Étude et devis gratuits, sans engagement</li>
                <li>• Un seul interlocuteur, de la conception à la pose</li>
                <li>• Fabrication en atelier et pose par nos équipes</li>
                <li>• Intervention en France et en Suisse</li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
